import HeroSection from "../../components/HeroSection";
import OnlineCourses from "../../components/OnlineCourses";
import OurInstructours from "../../components/Our-Instructors";
import PopularInstructor from "../../components/Popular-Instructours";
import TrustedCompanies from "../../components/TrustedCompanies";
import WhyChoose from "../../components/WhyChoose";

function Home() {
  return (
    <>
      <HeroSection />
      <PopularInstructor />
      <OurInstructours />
      <TrustedCompanies />
      <OnlineCourses />
      <WhyChoose />
    </>
  );
}
export default Home;
